<template>
    <div class="com-codics-hbb-order-admin-cusinfo-add-body" ref="bjBody">
        <div class="iconfont com-codics-hbb-order-admin-cusinfo-add-back" @click="jumpToPage('客户管理', {}, {})">&#xe842;
            返回页面
        </div>
        <div class="com-codics-hbb-order-admin-cusinfo-add-bar-content"
            style="width:100% !important;padding:50px 0 !important;">
            <MyStep v-model="stepNum" :data="stepData" :size="10"></MyStep>
        </div>
        <div class="com-codics-hbb-order-admin-cusinfo-add-bar-content com-codics-hbb-order-admin-cusinfo-add-bar-content2"
            style="margin-top: 10px;">
            <MyForm v-show="stepNum == 1" style="margin-top: 30px;">
                <MyFormItem style="width:50%;" label="客户名称" required>
                    <el-input v-model="addForm.name" placeholder="请输入客户名称" style="width:217px;" clearable></el-input>
                </MyFormItem>
                <MyFormItem style="width:50%;" label="联系方式" required>
                    <el-input v-model="addForm.phone" placeholder="请输入客户联系方式" maxLength="11" style="width:217px;"
                        clearable></el-input>
                </MyFormItem>
                <MyFormItem style="width:50%;" label="邮箱">
                    <el-input v-model="addForm.email" placeholder="请输入客户邮箱" style="width:217px;" clearable></el-input>
                </MyFormItem>
                <MyFormItem label="所属公司" required>
                    <el-input v-model="addForm.com" placeholder="请输入客户所属公司" style="width:217px;" clearable></el-input>
                </MyFormItem>
                <MyFormItem label="客户地址">
                    <el-input v-model="addForm.area" placeholder="请输入客户地址信息" style="width:217px;" clearable></el-input>
                </MyFormItem>
                <MyFormItem label="所属国家">
                    <el-cascader style="width:380px;" :props="{ checkStrictly: true }" size="large" filterable
                        :options="areaOptions" v-model="addForm.country" clearable>
                    </el-cascader>
                </MyFormItem>
                <MyFormItem label="宗教信息">
                    <el-input v-model="addForm.religion" placeholder="请输入客户宗教信息" style="width:217px;"
                        clearable></el-input>
                </MyFormItem>
                <MyFormItem label="客户评级">
                    <el-input v-model="addForm.rating" placeholder="请输入客户评级" style="width:217px;" clearable></el-input>
                </MyFormItem>
                <MyFormItem label="客户来源">
                    <el-input v-model="addForm.srce" placeholder="请输入客户来源" style="width:217px;" clearable></el-input>
                </MyFormItem>
            </MyForm>
            <el-image v-show="stepNum == 2" style="left: 50%;transform: translateX(-50%);"
                src="https://cdn.bosscaigou.com/huayuan/img/%E6%8F%90%E4%BA%A4%E6%88%90%E5%8A%9F.svg"
                fit="fill"></el-image>
            <div v-show="stepNum == 2"
                style="position: relative;float:left;left: 50%;transform: translateX(-50%);width: 100%;margin-bottom: 40px;text-align: center;font-size: 14px;color: #777;">
                添加报价信息成功</div>
        </div>
        <div class="com-codics-hbb-order-admin-cusinfo-add-bottom-bar" ref="btBody">
            <el-button @click="nextStep" size="small"
                style="position:relative;float:right;top:50%;transform:translateY(-50%);margin-right:10px"
                :type="stepNum == 2 ? 'success' : 'primary'">{{ stepNum == 1 ? '确认，创建' : '返回报价页面' }}</el-button>
        </div>
    </div>
</template>


<script>
import areaData from '../../../../public/data/data2.json';
import MyForm from '@/components/MyForm';
import MyFormItem from '@/components/MyForm/MyFormItem';
import MyStep from '@/components/MyStep';
import MyButton from '@/components/MyButton';
import { addCusInfo } from '@/api';
import { jumpTo } from '@/utils/myutils';
export default {
    data() {
        return {
            areaOptions: areaData,
            comData: [
                {
                    com: '山东华远创智信息技术有限公司',
                    area: '山东省淄博市张店区宏程国际智谷大厦1605室',
                    icon: 'https://cdn.bosscaigou.com/huayuan/img/yasuo_image1.webp',
                    seal: 'https://cdn.bosscaigou.com/huayuan/img/yasuo_image2.webp'
                }
            ],
            comInfoValue: null,
            stepNum: 1,
            stepData: [
                {
                    icon: '&#xe808;',
                    title: '询价信息',
                    content: '请根据需要填写询价信息，填写完成后点击确认完成创建'
                },
                {
                    icon: '&#xe84c;',
                    title: '生成询价信息',
                    content: '询价信息生成完成，手动返回或等待页面完成自动跳转'
                }
            ],
            addForm: {
                com: '',
                area: '',
                name: '',
                phone: '',
                email: '',
                country: '',
                religion: '',
                rating: '',
                srce: ''
            }
        }
    },
    components: {
        MyButton,
        MyStep,
        MyForm,
        MyFormItem
    },
    mounted() {
    },
    methods: {
        handleComChange(value) {
            if (value != '') {
                this.addForm = { ...this.addForm, ...value };
            } else {
                this.addForm.com = null;
                this.addForm.area = null;
                this.addForm.icon = null;
                this.addForm.seal = null;
            }
        },
        jumpToPage(n, p, q) {
            jumpTo(this, n, p, q);
        },
        async nextStep() {

            if (this.stepNum == 1) {

                if (this.addForm.name == '' || this.addForm.phone == '' || this.addForm.com == '') {

                    this.$message({
                        showClose: true,
                        message: '询价单位标注*的信息不能为空！',
                        type: 'warning'
                    });

                    return true;

                }

                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                this.addForm.phone = this.addForm.phone.toString();

                const data = await addCusInfo(this.addForm);

                loading.close();

                if (data.code == 200) {

                    this.stepNum++;

                } else {

                    if (data.code == 401) return;

                    this.$message.error(data.message);

                }

            } else if (this.stepNum == 2) {

                jumpTo(this, '客户管理', {}, {});

            }
        },
    }
}
</script>

<style>
.com-codics-hbb-order-admin-cusinfo-add-body {
    height: calc(100vh - 100px);
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    overflow-y: scroll;
    width: calc(100% + 20px);
    overflow-y: scroll;
    padding-right: 20px;
}

:root {
    --cusinfo-add-back-font-color: #333;
    --cusinfo-add-bottom-bg-color: #FFF;
    --cusinfo-add-bottom-shadow-color: #EBEBEB;
}

:root[data-theme="dark"] {
    --cusinfo-add-back-font-color: #FFF;
    --cusinfo-add-bottom-bg-color: #292b2c;
    --cusinfo-add-bottom-shadow-color: #2E3235;
}

.com-codics-hbb-order-admin-cusinfo-add-back {
    height: 50px;
    width: 100%;
    position: relative;
    float: left;
    line-height: 50px;
    box-sizing: border-box;
    font-size: 14px;
    color: var(--cusinfo-add-back-font-color);
    font-weight: bolder;
    cursor: pointer;
    transition: .3s;
    user-select: none;
    margin-bottom: 5px;
    -webkit-user-drag: none;
}

.com-codics-hbb-order-admin-cusinfo-add-bottom-bar {
    height: 50px;
    width: 100%;
    position: fixed;
    bottom: 0;
    right: 0;
    box-sizing: border-box;
    background: #FFF;
    background: var(--cusinfo-add-bottom-bg-color);
    border: 1px solid #EBEBEB;
    border: 1px solid var(--cusinfo-add-bottom-shadow-color);
    transition: .1s;
    padding-left: 20px;
}

.com-codics-hbb-order-admin-cusinfo-add-bar-content {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    background: var(--sbar-bg-color);
    border-radius: 6px;
    border: 1px solid var(--sbar-l-3-color);
    padding: 15px;
    transition: .3s;
}

.com-codics-hbb-order-admin-cusinfo-add-bar-content2 {
    box-sizing: border-box;
    padding: 20px;
}

.com-codics-hbb-order-admin-cusinfo-add-bar-pick {
    position: relative;
    float: left;
    box-sizing: border-box;
    margin-right: 15px;
}

.com-codics-hbb-order-admin-cusinfo-add-bar-input {
    width: 220px !important;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-news-pagination {
    height: fit-content;
    position: relative;
    float: left;
    /* left: 50%; */
    margin-top: 20px;
    /* transform: translateX(-50%); */
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
    background-color: var(--el-table-page-bg-color) !important;
    color: var(--el-table-page-font-color) !important;
}

.el-pagination.is-background .el-pager .active {
    background-color: var(--el-table-page-bg-active-color) !important;
    color: var(--el-table-page-font-active-color) !important;
}

.com-codics-hbb-order-admin-goods-img-upload .el-upload {
    display: var(--dataSize);
}

/* .com-codics-hbb-order-admin-cusinfo-add-info-box{
    height:fit-content;
} */

.com-codics-hbb-order-admin-cusinfo-add-info-item-delete {
    height: 40px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    line-height: 40px;
    cursor: pointer;
    transition: .3s;
    user-select: none;
    -webkit-user-drag: none;
    font-size: 15px;
    color: #333;
    text-align: center;
    margin-top: 15px;
}

.com-codics-hbb-order-admin-cusinfo-add-info-item-delete::before {
    content: '';
    height: 1px;
    width: 95%;
    position: absolute;
    margin: auto;
    left: 0;
    top: -15px;
    right: 0;
    background: #EBEBEB;
}

.com-codics-hbb-order-admin-cusinfo-add-info-item-delete:hover {
    background: rgba(0, 0, 0, .3);
}

.com-codics-hbb-order-admin-cusinfo-add-info-item-del-btn {
    position: absolute;
    margin: auto;
    top: 50px;
    right: 20px;
    user-select: none;
    -webkit-user-drag: none;
}

.com-codics-hbb-order-admin-cusinfo-add-info-item {
    height: 100px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    margin-bottom: 20px;
}

.com-codics-hbb-order-admin-cusinfo-add-info-item-img {
    height: 100px;
    width: 100px;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.com-codics-hbb-order-admin-cusinfo-add-info-item-title {
    height: 50px;
    width: calc(100% - 200px);
    position: relative;
    float: left;
    box-sizing: border-box;
    line-height: 50px;
    font-size: 14px;
    color: #333;
    text-align: left;
    padding-left: 20px;
}

.com-codics-hbb-order-admin-cusinfo-add-info-item-price {
    height: 50px;
    width: calc(100% - 200px);
    position: relative;
    float: left;
    box-sizing: border-box;
    line-height: 50px;
    font-size: 14px;
    color: #333;
    text-align: left;
    padding-left: 20px;
}

.com-codics-hbb-order-admin-cusinfo-add-bottom-bar-price {
    height: 50px;
    width: fit-content;
    position: relative;
    float: left;
    box-sizing: border-box;
    line-height: 50px;
    font-size: 14px;
    text-align: left;
    color: #FE6446;
    font-weight: bolder;
}
</style>